import { productsCatalogMutations } from "./products/mutations";
import { product_groupsCatalogMutations } from "./product_groups/mutations";
import { releasesCatalogMutations } from "./releases/mutations";
import { tracksCatalogMutations } from "./tracks/mutations";
import { artistsCatalogMutations } from "./artists/mutations";
import { labelsCatalogMutations } from "./labels/mutations";
import { CatalogModulePluginStore } from "./plugin-store";
import { projectsCatalogMutations } from "./projects/mutations";
export const mutations = {
  ...productsCatalogMutations,
  ...releasesCatalogMutations,
  ...product_groupsCatalogMutations,
  ...tracksCatalogMutations,
  ...artistsCatalogMutations,
  ...labelsCatalogMutations,
  ...projectsCatalogMutations,
  ...CatalogModulePluginStore.mutations
};
